import { useSelector } from "react-redux"
import { RootState } from "../../mp-core/redux/store"
import { useHistory, useLocation } from "react-router-dom"
import { useContext, useEffect, useMemo } from "react"
import {
  getRangeValue,
  getUserScopeFilters,
  transformQueryFilters
} from "../helpers"
import queryString from "query-string"
import isEqual from "lodash/isEqual"
import { getClearInitialSearchQuery } from "../helpers/filters"
import { FeatureFlagContext } from "../../mp-core/FeatureFlagProvider"
import { getUseSchoolYear } from "../helpers/flags"

type UseInitialFilters = Record<
  "initialFilters" | "initialUserFilters",
  { [key: string]: string[] }
>

export const useInitialFilters = (): UseInitialFilters => {
  const history = useHistory()
  const { search, pathname } = useLocation()
  const { featureFlags } = useContext(FeatureFlagContext)

  const user = useSelector((state: RootState) => state.users.testUser)

  const userStaticData = useMemo(() => getUserScopeFilters(user), [user])

  const initialUserFilters = useMemo(
    () => ({
      ...userStaticData,
      date: getUseSchoolYear()?getRangeValue("this school year"):undefined
    }),
    [userStaticData]
  )

  const searchQuery = useMemo(() => queryString.parse(search) || {}, [search])

  // Filtering of initial search data
  const filteredSearchQuery = useMemo(
    () => getClearInitialSearchQuery(searchQuery, userStaticData, featureFlags),
    [searchQuery, userStaticData]
  )

  const initialFilters = useMemo(
    () => transformQueryFilters(filteredSearchQuery, initialUserFilters),
    [userStaticData, initialUserFilters, filteredSearchQuery]
  )

  useEffect(() => {
    if (isEqual(searchQuery, filteredSearchQuery)) return

    const updatedSearchString = queryString.stringify(filteredSearchQuery)

    history.replace(
      `${pathname}${!!updatedSearchString ? `?${updatedSearchString}` : ""}`
    )
  }, [searchQuery, filteredSearchQuery])

  return { initialFilters, initialUserFilters }
}
